export const generateUrl = (route, params = {}, search = null) => {
    let { path } = route

    Object.entries(params).forEach(([key, value]) => {
        path = path.replace(`:${key}`, value)
    })

    if (search) {
        const searchParams = new URLSearchParams(search)
        path = `${path}?${searchParams.toString()}`
    }

    return path
}